import React from 'react';
import { CornerDownLeftIcon, NetworkIcon, SearchIcon, SparkleIcon, UserIcon } from 'lucide-react';
import { StatusPill } from '../ui/StatusPill';
const background = [{
  title: 'Hendricks et al., 2023',
  meta: 'Sleep · Cognition',
  status: '3 passages'
}, {
  title: 'Okafor & Lin, 2021',
  meta: 'Adolescent health',
  status: '5 passages'
}, {
  title: 'Varga et al., 2022',
  meta: 'Methods review',
  status: '2 passages'
}, {
  title: 'Moreau & Patel, 2020',
  meta: 'Attention',
  status: '4 passages'
}, {
  title: 'Sato et al., 2024',
  meta: 'Education outcomes',
  status: '1 passage'
}];
const results = [{
  group: 'Concepts',
  icon: NetworkIcon,
  title: 'Working memory',
  meta: '42 linked sources',
  active: true
}, {
  group: 'Findings',
  icon: SparkleIcon,
  title: 'Sleep fragmentation → Working memory',
  meta: 'Awaiting review',
  active: false
}, {
  group: 'People',
  icon: UserIcon,
  title: 'R. Lindqvist',
  meta: 'Curator · Cognitive Science',
  active: false
}];

/** A familiar command palette floating over a source library. */
export function CommandScene() {
  return <div className="relative mx-auto w-full max-w-xl" data-id="element-143" data-mp="h3zyx16hawki">
      <div className="rounded-[22px] bg-white/70 p-5 ring-1 ring-ink/[0.05]" aria-hidden="true" data-id="element-144" data-mp="h2f2t74in5kj">
        <div className="flex items-center justify-between" data-id="element-145" data-mp="c5f8fth13r99">
          <p className="text-sm font-semibold" data-id="element-146" data-mp="83tmzjqfi4ng">Sources</p>
          <span className="rounded-full bg-accent-soft px-2 py-0.5 text-[11px] font-medium text-accent-ink shadow-glow" data-id="element-147" data-mp="85ej3dse5vnf">
            3 new relationships
          </span>
        </div>
        <ul className="mt-4 divide-y divide-ink/[0.06]" data-id="element-148" data-mp="zv15aa9xhue3">
          {background.map(row => <li key={row.title} className="flex items-center justify-between py-2.5 text-[13px]" data-id="element-149" data-mp="v280jmegmm20">
              <span data-id="element-150" data-mp="r1o4yn9jbqhz">
                <span className="font-medium" data-id="element-151" data-mp="r039mvfec3j2">{row.title}</span>
                <span className="ml-2 text-ink-muted" data-id="element-152" data-mp="1nkviisy5tkyv">{row.meta}</span>
              </span>
              <span className="text-[12px] text-ink-faint" data-id="element-153" data-mp="1isaqnwytdhxz">{row.status}</span>
            </li>)}
        </ul>
      </div>

      <div className="glass-strong absolute inset-x-4 top-12 rounded-2xl shadow-window sm:inset-x-10" role="img" aria-label="Sample command palette searching for working memory" data-id="element-154" data-mp="3d1ze0an7gvz5">
        <div className="flex items-center gap-2.5 border-b border-ink/[0.06] px-4 py-3" data-id="element-155" data-mp="33amohpovqhwa">
          <SearchIcon className="h-4 w-4 text-ink-muted" aria-hidden="true" data-id="element-156" data-mp="389fs8qed6uj9" />
          <span className="text-sm text-ink" data-id="element-157" data-mp="2ua6l0g84zarf">
            working mem<span className="ml-px inline-block h-4 w-px translate-y-0.5 bg-accent" data-id="element-158" data-mp="2ucsuilel80ca" />
          </span>
          <kbd className="ml-auto rounded-md bg-ink/[0.05] px-1.5 py-0.5 text-[10px] font-medium text-ink-muted" data-id="element-159" data-mp="2z7pznh8qxpjw">esc</kbd>
        </div>
        <ul className="p-2" data-id="element-160" data-mp="2pb3eercicwhc">
          {results.map(r => {
          const Icon = r.icon;
          return <li key={r.title} data-id="element-161" data-mp="im8elftcy9wa">
                <p className="px-2 pb-1 pt-2 text-[10px] font-medium text-ink-faint" data-id="element-162" data-mp="ilyo7r4ei0q2">{r.group}</p>
                <div className={`flex items-center gap-3 rounded-xl px-2 py-2 ${r.active ? 'bg-accent-soft' : ''}`} data-id="element-163" data-mp="njgu18n4fztu">
                  <span className={`flex h-7 w-7 items-center justify-center rounded-lg ${r.active ? 'bg-accent text-white' : 'bg-ink/[0.05] text-ink-soft'}`} data-id="element-164" data-mp="27zy4zhicuxlf">
                    <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-165" data-mp="2hsvrdyqgx6pb" />
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-166" data-mp="2d0lx66iblkh8">
                    <span className="block truncate text-[13px] font-medium" data-id="element-167" data-mp="2qssevx14fzis">{r.title}</span>
                  </span>
                  {r.meta === 'Awaiting review' ? <StatusPill tone="warn" data-id="element-168" data-mp="2mt9s0vpqpedb">{r.meta}</StatusPill> : <span className="hidden text-[11px] text-ink-muted sm:inline" data-id="element-169" data-mp="30q6szpzkoc7x">{r.meta}</span>}
                  {r.active ? <CornerDownLeftIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-170" data-mp="16cxf7lzzu4jv" /> : null}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </div>;
}